<!--suppress HtmlUnknownTag, CheckTagEmptyBody -->
<template>
    <div role="tablist">
        <invoice-accordion-item v-for="(invoices, index) in invoiceTypes" :invoices="invoices" :key="index"></invoice-accordion-item>
    </div>
</template>

<script>
  export default {
    name: 'InvoiceAccordion',
    props: {
      invoiceTypes: {
        type: Object,
        required: true,
      },
    },
  };
</script>

<style scoped>

</style>
